























































































































import Vue from "vue";
import { mapGetters, mapState } from "vuex";
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc';
import isBetween from 'dayjs/plugin/isBetween';

export default Vue.extend({
  name: "Admin",
  computed: {
    ...mapState({
        animationTitles: 'animationTitles',
        schemeTitles: 'schemeTitles',
    }),
    ...mapGetters(["currentAccount"]),
  },
  mounted: async function() {
    await this.$store.dispatch("initialize");
    await this.$store.dispatch("connect");
    const t = this as any;
    dayjs.extend(utc)
    dayjs.extend(isBetween)
    t.currentBlock = t.currentBlock = await t.$store.state.web3.eth.getBlockNumber();;
    t.currentBlockTimestamp = new Date().getTime() * 1000;
    t.loadStats();
    t.lookupPhaseLen();
    t.lookupContractURI();
    t.lookupBaseURI();
    t.listenForBlocks();
    //t.lookupSales();
  },
  beforeDestroy: function() {
    (this as any).unsubscribeBlocks();
  },
  filters: {
    dateTime: function (timestamp: any) {
      return !timestamp ? '' : (dayjs as any)(timestamp).format("h:mm:ss A DD/MM/YYYY");
    },
  },
  methods: {
    mintLE: async function(){
      const t = this as any;
      if (t.leRecipient !== '') {
        t.$store.state.web3.eth.sendTransaction({
          from: t.currentAccount,
          to: t.$store.state.tinyboxesAddress,
          data: t.$store.state.contracts.tinyboxes.methods
            .mintLE(this.leRecipient)
            .encodeABI(),
        },
          async (err: any, txHash: string) => {
            const t = this as any;
            if (err) t.overlay = err.code === 4001 ? "" : "error";
            t.leRecipient = '';
          }
        );
      }
    },
    setPause: async function(state: boolean){
      const t = this as any;
      t.$store.state.web3.eth.sendTransaction({
        from: t.currentAccount,
        to: t.$store.state.tinyboxesAddress,
        data: t.$store.state.contracts.tinyboxes.methods
          .setPause(state)
          .encodeABI(),
      },
        async (err: any, txHash: string) => {
          const t = this as any;
          if (err) t.overlay = err.code === 4001 ? "" : "error";
          t.leRecipient = '';
          t.lookupPause();
        }
      );
    },
    setCountdown: async function(){
      const t = this as any;
      t.$store.state.web3.eth.sendTransaction({
        from: t.currentAccount,
        to: t.$store.state.tinyboxesAddress,
        data: t.$store.state.contracts.tinyboxes.methods
          .startCountdown(t.startBlock)
          .encodeABI(),
      },
        async (err: any, txHash: string) => {
          const t = this as any;
          if (err) t.overlay = err.code === 4001 ? "" : "error";
          t.leRecipient = '';
          t.lookupBlockStart();
        }
      );
    },
    syncBlockToDateTime() {
      const t = this as any;
      //t.startBlock = t.startDate + t.startTime;
    },
    syncDateTimeToBlock() {
      const t = this as any;
      // const blockDifference = t.startBlock - t.currentBlock;
      // const timeDifference = blockDifference * t.avgBlockTime;
      // t.startDate = timeDifference;
      // t.startTime = timeDifference;
    },
    loadStats() {
      const t = this as any;
      t.lookupSupply();
      t.lookupLimit();
      t.lookupPause();
      t.lookupBlockStart();
      t.lookupLE();
      t.lookupTokens();
      t.lookupPhase();
      t.loadCountdown();
    },
    loadCountdown() {
      const t = this as any;
      t.timeLeft = (t.blockStart - t.currentBlock) * 13350;
      t.pauseEndTimestamp = new Date(t.currentBlockTimestamp).getTime() + t.timeLeft;
      t.pauseEndTime = dayjs(t.currentBlockTimestamp).add(t.timeLeft, 'ms');
      t.pauseEndTimeUTC = dayjs(t.currentBlockTimestamp).add(t.timeLeft, 'ms');
    },
    lookupContractURI: async function() {
      (this as any).contractURI = await this.$store.state.contracts.tinyboxes.methods.contractURI().call();
    },
    lookupBaseURI: async function() {
      (this as any).baseURI = await this.$store.state.contracts.tinyboxes.methods.baseURI().call();
    },
    lookupSupply: async function() {
      (this as any).supply = await this.$store.state.contracts.tinyboxes.methods.totalSupply().call();
    },
    lookupLE: async function() {
      (this as any).leCount = await this.$store.state.contracts.tinyboxes.methods._tokenPromoIds().call();
    },
    lookupTokens: async function() {
      (this as any).tokenCount = await this.$store.state.contracts.tinyboxes.methods._tokenIds().call();
    },
    lookupLimit: async function() {
      (this as any).limit = await this.$store.state.contracts.tinyboxes.methods.TOKEN_LIMIT().call();
    },
    lookupPhase: async function() {
      (this as any).phase = await this.$store.state.contracts.tinyboxes.methods.currentPhase().call();
    },
    lookupPhaseLen: async function() {
      (this as any).phaseLen = await this.$store.state.contracts.tinyboxes.methods.phaseLen().call();
    },
    lookupPause: async function() {
      (this as any).paused = await this.$store.state.contracts.tinyboxes.methods.paused().call();
    },
    lookupBlockStart: async function() {
      (this as any).blockStart = await this.$store.state.contracts.tinyboxes.methods.blockStart().call();
    },
    async refreshTokenMetadata(id: string) {
      const refeshEndpoint  = 'https://api.opensea.io/asset/' + this.$store.state.tinyboxesAddress + '/' + id + '/?force_update=true';
      return await (this as any).$http.get(refeshEndpoint);
    },
    async refreshAllTokensMetadata() {
      // loop through all minted tokens
      let id = 0;
      for (id;id<=(this as any).tokenCount;id++)
        this.refreshTokenMetadata(id + '');
      // loop through all LE tokens
    },
    async lookupSales() {
      const t = this as any;
      t.transfers = await t.$http.get(
        "https://api.opensea.io/api/v1/events?asset_contract_address=" +
        t.$store.state.tinyboxesAddress +
        "&event_type=transfer&only_opensea=false&offset=0&limit=250"
      );
      const mints = t.transfers.data.asset_events.filter( (e: any) => e.from_account.address === "0x0000000000000000000000000000000000000000");
      const buys = mints.filter( (e: any) => {
        console.log(e.asset.token_id, e.asset.token_id < 2222)
        return e.asset.token_id < 2222
      });
      console.log(buys);
      // bin by hour / date created from launch time
      const hoursSinceLaunch = dayjs(t.saleStarted).diff(new Date(), 'hour');
      console.log(hoursSinceLaunch)
      for (let h=0; h < hoursSinceLaunch; h++) {
        const range = [
          dayjs(t.saleStarted).add(h, "hour"),
          dayjs(t.saleStarted).add(h+1, "hour")
        ];
        const count = buys.filter( (e: any) => {
          return dayjs(e.created_date).isBetween(range[0], range[1]);
        }).length;
        t.sales.push(count);
      }
    },
    listenForTokens: function() {
      const t = this as any;
      const tokenSubscription = t.$store.state.web3.eth
        .subscribe("logs", {
          address: t.$store.state.tinyboxesAddress,
          topics: [
            "0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef",
            "0x0000000000000000000000000000000000000000000000000000000000000000"
          ]
        })
        .on(
          "data",
          async function(log: any) {
            const id = BigInt(log.topics[3]);
            console.log(id);
          }.bind(t)
        )
        .on("error", function(log: any) {
          console.error(log)
        });
    },
    listenForBlocks: function() {
      const t = this as any;
      t.blockSubscription = t.$store.state.web3.eth
        .subscribe("newBlockHeaders", function(error: any, result: any){
            if (!error) {
                //console.log(result);
                return;
            }
            console.error(error);
        })
        .on("data", async function(blockHeader: any) {
          t.currentBlock = blockHeader.number;
          t.currentBlockTimestamp = blockHeader.timestamp * 1000;
          t.loadStats();
        })
        .on("error", console.error);
    },
    unsubscribeBlocks: function() {
        // unsubscribes the subscription
        (this as any).blockSubscription.unsubscribe(function(error: any, success: any){
            if (success) {
                console.log('Successfully unsubscribed blocks listener');
            }
        });
    },
  },
  data: () => ({
    loading: true,
    paused: false,
    avgBlockTime: 15000,
    datePicker: false,
    timePicker: false,
    sales: [],
    transfers: [],
    saleStarted: new Date("2021-01-30T18:42:37.780772"),
    startBlock: null as number | null,
    startDate: null as number | null,
    startTime: null as number | null,
    currentBlock: null as number | null,
    currentBlockTimestamp: null as number | null,
    timeLeft: null as number | null,
    pauseEndTime: null as any,
    pauseEndTimeUTC: null as any,
    pauseEndTimestamp: null as number | null,
    blockStart: null as number | null,
    blockSubscription: null,
    supply: null as number | null,
    limit: null as number | null,
    leCount: null as number | null,
    tokenCount: null as number | null,
    phase: null as number | null,
    phaseLen: null as number | null,
    tokenID: "",
    baseURI: '',
    contractURI: '',
    leRecipient: '',
  }),
});
